import {
  StyledTableContainer,
  StyledTable,
  StyledTableHeader,
  StyledHeaderColumn,
  StyledTableRow,
  StyledTableData,
  HeaderCellContent,
} from "./index.styles";
import { formatColumnLabel } from "../../../../helper/columnLabel";

export const Table = ({ children, containerStyle, ...props }) => {
  return (
    <StyledTableContainer style={containerStyle} {...props}>
      <StyledTable>{children}</StyledTable>
    </StyledTableContainer>
  );
};

export const TableHeader = ({ children, ...props }) => {
  return (
    <StyledTableHeader {...props}>
      <tr>{children}</tr>
    </StyledTableHeader>
  );
};

export const HeaderColumn = ({ children, centerAlign, rightAlign, showFilter, ...props }) => {
  const className = [centerAlign ? "centerAlign" : "", rightAlign ? "rightAlign" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <StyledHeaderColumn className={className} {...props}>
      <HeaderCellContent
        style={{ justifyContent: centerAlign ? "center" : rightAlign ? "flex-end" : "flex-start" }}
      >
        {formatColumnLabel(children)}
      </HeaderCellContent>
    </StyledHeaderColumn>
  );
};

export const TableRow = ({ children, isSelected, ...props }) => {
  const className = isSelected ? "selectedRow" : "";
  return (
    <StyledTableRow className={className} {...props}>
      {children}
    </StyledTableRow>
  );
};

export const TableData = ({ children, centerAlign, rightAlign, ...props }) => {
  const className = [centerAlign ? "centerAlign" : "", rightAlign ? "rightAlign" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <StyledTableData className={className} {...props}>
      {children}
    </StyledTableData>
  );
};
